import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import { DropdownButton, Dropdown, Table, Row, Col, Card } from 'react-bootstrap';
// CSS 
import "../../src/assets/Footer.css";

// images 
import main_logo from '../assets/images/UPG_site_logo.png';

function Footer() {
    return (
        <>
            <div className='container-fluid footer_main_div'>
                <div className='container px-2 py-4 pb-2'>
                    <Row className='justify-content-center pb-md-5 pb-4'>
                        <Col lg={3} md={4} className='mobile_view_block_center text-center'>

                            <a href="/"> <img src={main_logo} alt="logo_img" className='foterlogo_img' /></a>
                            {/* <div className='fs-6 mt-2'>
                                United Sports like Basketball,
                                Table Tennis, Bowling, and
                                2K Run.
                            </div> */}
                        </Col>
                        <Col lg={3} md={4} className='mt-4 mobile_view_block_center'>
                            <ul className='ps-md-5'>
                                <li>
                                    <NavLink className='nav_page_btn fw-normal' to='/faqs' activeClassName='active'>
                                        FAQ
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink className='nav_page_btn fw-normal' to='/contact' activeClassName='active'>
                                        Get in Touch
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink className='nav_page_btn fw-normal' to='/privacy&policy' activeClassName='active'>
                                        Privacy Policy
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink className='nav_page_btn fw-normal' to='/terms&condition' activeClassName='active'>
                                        Terms & Conditions
                                    </NavLink>
                                </li>
                            </ul>
                        </Col>
                        <Col lg={3} md={4} className='mt-4'>
                            <div className='fotr_icon_div'>
                                <a target='_blank' href="https://www.facebook.com/share/17xrcQ8zCi"> <i class="bi bi-facebook"></i> </a>
                                <a target='_blank' href="https://www.instagram.com/unitedpremiergames"> <i class="bi bi-instagram"></i></a>
                            </div>
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <div className='copy_write_footer_text pt-2'>
                            © One Vision Sports Pty Ltd All Rights Reserved
                        </div>
                    </Row>
                </div>

            </div>
        </>
    )
}

export default Footer
